export const GenericError = "Something went wrong, please try again."

export const PublicHostURL = process.env.REACT_APP_PUBLIC_HOST_URL || "http://localhost:5002"
export const AdminHostURL = process.env.REACT_APP_ADMIN_HOST_URL || "http://localhost:5002"

export const IsAdmin = process.env.REACT_APP_BUILD_TARGET === "ADMIN"
export const IsPublic = process.env.REACT_APP_BUILD_TARGET === "PUBLIC"
